<script lang="ts" setup>
import SpecialDecoSign from "@/components/ResultCard/SpecialDecoSign.vue";

defineProps({
    label: {
        type: String,
        required: true,
    },
    isSpecial: {
        type: Boolean,
        default: false,
    },
});
</script>
<template>
    <div class="[ c-card__tag ]" :class="{ 'c-card__tag--special': isSpecial }">
        <span>
            <span v-if="isSpecial">
                <SpecialDecoSign />
            </span>
            {{ label }}
            <span v-if="isSpecial">
                <SpecialDecoSign />
            </span>
        </span>
    </div>
</template>
